import { useEffect } from "react";

export const IubendaTerms = () => {
  useEffect(() => {
    const loadIubenda = () => {
      const script = document.createElement("script");
      script.src = "https://cdn.iubenda.com/iubenda.js";
      script.async = true;
      document.body.appendChild(script);
    };

    loadIubenda();

    return () => {
      const script = document.querySelector(
        'script[src="https://cdn.iubenda.com/iubenda.js"]'
      );
      if (script) {
        script.remove();
      }
    };
  }, []);

  return (
    <div
      className="[&_#iub-pp-container_h1]:text-base-foreground [&_#iub-pp-container_h1]:text-2xl [&_#iub-pp-container_h1]:font-medium
                    [&_#iub-pp-container_h2]:text-base-foreground [&_#iub-pp-container_h2]:text-2xl [&_#iub-pp-container_h2]:font-medium [&_#iub-pp-container_h2]:my-4
                    [&_#iub-pp-container_h3]:text-base-foreground [&_#iub-pp-container_h3]:text-2xl [&_#iub-pp-container_h3]:font-medium [&_#iub-pp-container_h3]:my-2
                    [&_#iub-pp-container_h4]:text-base-foreground [&_#iub-pp-container_h4]:text-xl [&_#iub-pp-container_h4]:font-medium  [&_#iub-pp-container_h4]:my-2
                    [&_#iub-pp-container_ul]:text-base-foreground [&_#iub-pp-container_ul]:text-sm [&_#iub-pp-container_ul]:font-normal [&_#iub-pp-container_ul]:list-disc [&_#iub-pp-container_ul]:pl-4
                    [&_#iub-pp-container_p]:text-base-foreground [&_#iub-pp-container_p]:text-sm [&_#iub-pp-container_p]:font-normal
                    [&_#iub-pp-container_ul_p]:mb-0
                    [&_#iub-pp-container_.iub_header_+_p]:mb-0
                    [&_#iub-pp-container_ul:has(+_ul)]:mb-2"
    >
      <a
        style={{ opacity: 0 }}
        href="https://www.iubenda.com/terms-and-conditions/46122265"
        className="iubenda-nostyle iubenda-noiframe iubenda-embed iub-no-markup iubenda-noiframe iub-body-embed"
        title="Terms and Conditions"
      >
        Terms and Conditions
      </a>
    </div>
  );
};
